import { render, staticRenderFns } from "./RotatingNumber.vue?vue&type=template&id=153ed76a&scoped=true&"
import script from "./RotatingNumber.vue?vue&type=script&lang=js&"
export * from "./RotatingNumber.vue?vue&type=script&lang=js&"
import style0 from "./RotatingNumber.vue?vue&type=style&index=0&id=153ed76a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153ed76a",
  null
  
)

export default component.exports